"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingPayout = void 0;
var account_1 = require("../account");
/**
 * @deprecated Старый класс, сейчас не используется.
 * Вместо него используется BillingTransaction, как более информативный.
 *
 * @description Выплата средств на банковский счёт пользователя или банковскую карту
 */
var BillingPayout = /** @class */function () {
  function BillingPayout(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'account_id', 'currency_id', 'amount', 'status', 'note'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.created_at = values.created_at instanceof Date ? values.created_at : new Date(values.created_at);
    instance.currency = account_1.currencies[values.currency_id];
  }
  return BillingPayout;
}();
exports.BillingPayout = BillingPayout;
